import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-foreground-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-star-fill text-background-50 text-lg"></i>
              </div>
              <span className="font-heading text-lg font-semibold text-foreground-50 whitespace-nowrap">
                亚洲精品一区二区
              </span>
            </Link>
            <p className="text-foreground-400 text-sm leading-relaxed max-w-md">
              亚洲精品一区二区为您提供专业分区内容导览，涵盖一区精品推荐与二区优质资源，精准分类、快速定位，满足您对亚洲精品内容的多样化需求。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-100 mb-4">
              快速导航
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-foreground-400 hover:text-foreground-100 text-sm transition-colors">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/category/zone1" className="text-foreground-400 hover:text-foreground-100 text-sm transition-colors">
                  一区精品
                </Link>
              </li>
              <li>
                <Link to="/category/zone2" className="text-foreground-400 hover:text-foreground-100 text-sm transition-colors">
                  二区资源
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-foreground-400 hover:text-foreground-100 text-sm transition-colors">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-100 mb-4">
              热门标签
            </h4>
            <div className="flex flex-wrap gap-2">
              {['一区精品', '二区资源', '内容推荐', '深度解读', '行业分析', '创作者访谈'].map((tag) => (
                <span
                  key={tag}
                  className="px-3 py-1 text-xs rounded-full bg-background-800 text-foreground-300 whitespace-nowrap"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-foreground-500 text-xs">
            &copy; 2024-2026 亚洲精品一区二区 版权所有
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-foreground-500 hover:text-foreground-200 text-xs transition-colors">隐私政策</a>
            <a href="#" className="text-foreground-500 hover:text-foreground-200 text-xs transition-colors">服务条款</a>
            <a href="#" className="text-foreground-500 hover:text-foreground-200 text-xs transition-colors">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}